import { Injectable } from '@angular/core';
import { PropertyViewConfig } from './feed-settings.service';
import { TranslateService } from '@ngx-translate/core';
import { User } from '../models/core.models';

@Injectable({
  providedIn: 'root',
})
export class HomeSettingsService {
  private homeConfiguration;
  private configLoaded = false;

  constructor(private translate: TranslateService) {}

  async initializeConfigurations(): Promise<void> {
    const keys = [
      'home.view-settings.time-created',
      'home.view-settings.time-modified',
      'home.view-settings.stats',
    ];

    const translations = await this.translate.get(keys).toPromise();

    const homeProperties: PropertyViewConfig[] = [
      {
        label: translations['home.view-settings.time-created'],
        path: 'time_created',
        propertyUri: 'time_created',
        icon: ['fas', 'clock'],
        selected: false,
        visibility: ['tools'],
        isRadio: false,
      },
      {
        label: translations['home.view-settings.time-modified'],
        path: 'time_modified',
        propertyUri: 'time_modified',
        icon: ['fas', 'clock'],
        selected: false,
        visibility: ['tools'],
        isRadio: false,
      },
      {
        label: translations['home.view-settings.stats'],
        path: 'stats',
        propertyUri: 'stats',
        icon: ['fas', 'chart-simple'],
        selected: false,
        visibility: ['tools'],
        isRadio: false,
      },
    ];

    this.homeConfiguration = [...homeProperties];
    this.configLoaded = true;
  }

  getHomeViewConfig(user: User): Promise<PropertyViewConfig[]> {
    return new Promise(async (resolve) => {
      if (!this.configLoaded) {
        await this.initializeConfigurations();
      }
      let homeConfig = this.homeConfiguration;
      if (homeConfig) {
        homeConfig = homeConfig.filter((config) => {
          return (
            !config.permission || user?.feature_components[config.permission]
          );
        });
      }
      resolve(homeConfig);
    });
  }
}
